module.exports = __webpack_public_path__ + "static/img/高新技术企业证书.56843d19.jpg";